<template lang="pug">
v-container.View.View--EditProfile
  v-snackbar(v-model="showSuccessSnackbar" color="success" :timeout="3000")
    | Informazioni aggiornate
    v-btn(dark text @click="showSuccessSnackbar = false") Ok
  v-card(v-if="!loading")
    v-card-text.pt-4
      .title.mb-2 Modifica informazioni account
      ValidationObserver(v-slot="{ invalid, validated, passes }")
        v-form
          v-layout(wrap)
            v-flex(xs12)
              ValidationProvider(name="Nome" rules="required" v-slot="{ errors }")
                v-text-field(
                  v-model="profile.name" required
                  name="nome" type="text"
                  :error-messages="errors"
                  label="Nome" prepend-inner-icon="mdi-account"
                )
            v-flex(xs12)
              ValidationProvider(name="Cognome" rules="required" v-slot="{ errors }")
                v-text-field(
                  v-model="profile.surname" required
                  name="cognome" type="text"
                  :error-messages="errors"
                  label="Cognome" prepend-inner-icon="mdi-account"
                )
            v-flex(xs12)
              ValidationProvider(name="Telefono" rules="min:9" v-slot="{ errors }")
                v-text-field(
                  v-model="profile.phone"
                  name="telefono" type="text"
                  :error-messages="errors"
                  label="Telefono" prepend-inner-icon="mdi-phone"
                )
            v-flex(xs12)
              v-btn.secondary(
                @click="passes(updateProfile)" :disabled="invalid"
                :loading="loading" block
              ) Conferma modifiche
      br
      .title.my-2 Aggiorna password
      ValidationObserver(v-slot="{ invalid, validated, passes }")
        v-form
          v-layout(wrap)
            v-flex(xs12)
              ValidationProvider(name="Password corrente" rules="required|min:6" v-slot="{ errors }")
                v-text-field(
                  v-model="credentials.oldpassword" required
                  name="password corrente" type="password"
                  :error-messages="errors"
                  label="Vecchia password" prepend-inner-icon="mdi-asterisk"
                )
            v-flex(xs12)
              ValidationProvider(name="Nuova password" rules="required|min:6" v-slot="{ errors }" vid="password")
                v-text-field(
                  v-model="credentials.password" required
                  name="nuova password" type="password"
                  :error-messages="errors"
                  label="Nuova password" prepend-inner-icon="mdi-asterisk"
                )
            v-flex(xs12)
              ValidationProvider(name="Conferma password" rules="required|min:6|confirmed:password" v-slot="{ errors }")
                v-text-field(
                  v-model="credentials.password_confirm" required
                  name="conferma password" type="password"
                  :error-messages="errors"
                  label="Conferma nuova password" prepend-inner-icon="mdi-asterisk"
                )
            v-flex(xs12)
              v-btn(
                @click="passes(updatePassword)" :disabled="invalid || !validated"
                :loading="loading"
                block color="secondary"
              ) Aggiorna password
  template(v-else)
    Loading
</template>

<script>
import User from "@/api/User";
import Loading from "@/components/Loading";

export default {
  name: "EditProfile",
  components: { Loading },
  data: function() {
    return {
      profile: {},
      credentials: {},

      loading: false,
      showSuccessSnackbar: false
    };
  },

  async mounted() {
    this.loading = true;

    this.$emit("update:title", "Modifica account");
    this.profile = await User.getProfile();
    this.loading = false;
  },

  methods: {
    async updateProfile() {
      this.loading = true;
      await User.updateProfile({
        name: this.profile.name,
        surname: this.profile.surname,
        phone: this.profile.phone
      });
      this.showSuccessSnackbar = true;
      this.loading = false;
    },

    async updatePassword() {
      this.loading = true;
      await User.changePassword({
        oldPassword: this.credentials.oldpassword,
        newPassword: this.credentials.password
      });
      this.showSuccessSnackbar = true;
      this.loading = false;
    }
  }
};
</script>
